import React from "react";

import { useToaster } from "utils";

export interface ClipboardTextProps {
  text: string;
  displayText?: string | React.ReactNode;
  className?: string;
}
export const ClipboardText = ({ text, displayText, className = "" }: ClipboardTextProps) => {
  const { showInfo } = useToaster();
  return (
    <span
      onClick={() => {
        navigator.clipboard.writeText(text);
        showInfo("Skopiowano");
      }}
      className={`cursor-pointer ${className}`}
    >
      {displayText ?? text}
    </span>
  );
};
